const storyElements=
{
//controls the order that items appear in sentences

middleList:[//these are features which are placed immediately before the symptom in the sentence
"Site",
"Site(s)",
"symptom",
"Side",
"Area(s)_of_axilla",
"Nodularity",
"Type_of_squint"
],

endList:[// these are features which are placed after the symptom in the sentenec
"Frequency",
"Occurs:",
"Present_for_several:",
"Duration:",
"Site(s)_of_bleeding",
"Maximum_Temperature_(C)",
"Extent:",
"Containing:",
"Character:",
"Relationship_to_stool:",
"Type_of_lesion",
"Problem:",
"Blood_clots:",
"Nocturnal_erections:",
"Any other information:",
"Description",
"Infective_agent",
"Area_involved",
"Mass_or_Ulcer",
"Blood_stained",
"Problem",
"Relationship_to_sputum:",
"Findings",
"Max_Size_(cm)",
"Features",
"Features_suggesting",
"Side_of_mouth",
"Thyroid_Auscultation:",
"Headache_features",
"Nature_of_concern:"
],
a_list:// sypmptoms where an "a" needs to be added to the start of the sentence in other circumstances than when a size is involved- which is already covered int he storycore code
[
"Squint (children)",
"Headache"  
],

skipParse: // elements which should not be passed throught the array parser
["Headache_features"

] 



    



  
}

export default storyElements